define('plugin/user-license/UserLicensePlugin',['require','marionette','lib/plugin/PluginAbstract','plugin/user-license/controller/UserLicenseController','lib/AppRouter'],function (require) {

    var Marionette = require('marionette');
    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var UserLicenseController = require('plugin/user-license/controller/UserLicenseController');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        initialize: function () {
            var newsRouter = new AppRouter({
                appRoutes: {
                    'terms-and-conditions': 'index'
                },
                menuItem: 'terns_and_conditions',
                controller: new UserLicenseController({
                    app: this.getOption('app')
                })
            });
        }

    });

});
